import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchTerminals} from '../actions/terminal'
import {fetchSettings} from '../actions/setting'
import {fetchOsSettings} from '../actions/ossetting'
import {fetchFilterDatas} from '../actions/filter'
import TerminalEdit from '../components/TerminalEdit';

const mapStateToProps = state => {
  const { terminal } = state
  const { setting } = state
  const { ossetting } = state
  const {
    isFetching,
    lastUpdated,
    items,
    totalRows
  } = terminal || {
    isFetching: true,
    items: []
  }

  const usersMaster = setting.items || [];
  const ositems = ossetting.items || [];

  return {
    items,
    isFetching,
    lastUpdated,
    totalRows,
    usersMaster,
    ositems
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTerminals: fetchTerminals,
      getSettings: fetchSettings,
      getOsSettings: fetchOsSettings,
      getFilterDatas:fetchFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(TerminalEdit)
